import React, { useEffect } from 'react';
import Layout from '../components/Layout';
import { emailAddresses } from '../config/emails';
import SEO from '../components/SEO';
import { canonicalUrlFor, metaDescription } from '../utils/seo';

const Contact: React.FC = () => {
  const helloEmail = emailAddresses.hello;
  const supportEmail = emailAddresses.support;

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  return (
    <Layout>
      <SEO
        title="Contact OppFoundry"
        description={metaDescription('Get in touch with OppFoundry for support, feedback, or partnerships.')}
        canonical={canonicalUrlFor()}
      />
      <div className="space-y-8">
        <div className="max-w-3xl space-y-4">
          <h1 className="text-3xl font-semibold text-gray-900">Get in touch</h1>
          <p className="text-base text-gray-600">
            Whether you need help, have feedback, feature requests, complaints, or just want to chat, we’re eager to hear from
            you. OppFoundry is brand new and feedback is eagerly desired so that we can continue to improve it and make it more
            valuable to you. Please don’t be a stranger.
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          <div className="rounded-2xl border border-blue-100 bg-blue-50 p-6">
            <h2 className="text-lg font-semibold text-blue-900">General inquiries</h2>
            <p className="mt-2 text-sm text-blue-900/90">
              Start here for anything OppFoundry related—product feedback, partnerships, or just to say hi.
            </p>
            <a
              href={`mailto:${helloEmail}`}
              className="mt-4 inline-flex items-center justify-center rounded-md bg-blue-600 px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-blue-500"
            >
              Email {helloEmail}
            </a>
          </div>

          <div className="rounded-2xl border border-gray-200 bg-white p-6">
            <h2 className="text-lg font-semibold text-gray-900">Product support</h2>
            <p className="mt-2 text-sm text-gray-600">
              Need help with your account or noticed something off? Send us a quick note and we&apos;ll troubleshoot with you.
            </p>
            <a
              href={`mailto:${supportEmail}`}
              className="mt-4 inline-flex items-center text-sm font-semibold text-blue-600 hover:text-blue-500"
            >
              {supportEmail}
            </a>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Contact;
